module.exports = __webpack_public_path__ + "static/media/explodedStripe.3a642aa3.png";